import dummyQuery from './dummyQuery';
export default { dummyQuery };
